import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { GetNewsProps } from 'models';

export const getNews = createAsyncThunk('news/getNews', async (params: GetNewsProps) => {
	return await NewsService.getAll(params);
});
